<template>
  <v-container class="px-1">
    <v-form ref="filterUploadsMonitor">
      <v-row>
          <v-col class="py-0 px-2" cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateI = parseDate(dateIFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0 px-2" cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateF = parseDate(dateFFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id'); changePrestador()" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="2">
            <label>Prestador</label>
            <v-select
                v-model="formData.prestador_id"
                :items="prestadoresFilter"
                item-value="id"
                item-text="prest_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="changePrestador"
            ></v-select>
          </v-col> -->
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="operadorasFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="2">
            <label>Operadora</label>
            <v-select
                v-model="formData.operadora_ans_id"
                :items="operadorasFilter"
                item-value="id"
                item-text="oper_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
            ></v-select>
          </v-col> -->
        <v-col class="py-0" cols="12" sm="6" md="2">
          <label>Enviado por</label>
          <v-select
            v-model="formData.user_id_upload"
            :items="responsaveisFilter"
            item-value="Id"
            item-text="UserName"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>Status</label>
            <v-select
              v-model="formData.status"
              :items="statusFilter"
              item-value="id"
              item-text="descricao"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              outlined
            >
              <template v-slot:item="data">
                <template v-if="(typeof data.item!=='object')">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                  </v-list-item-content>
                   <v-list-item-icon>
                    <v-icon v-text="data.item.icon" :color="data.item.color" x-small></v-icon>
                  </v-list-item-icon>
                </template>
              </template>
            </v-select>
          </v-col>
          <v-col class="pt-5 px-2" cols="2">
              <v-spacer></v-spacer>
              <v-btn
                small 
                height="32px"
                color="primary"
                class="px-1 mr-3"
                depressed
                @click="sendFilter()"
                >Filtrar</v-btn>
              <v-btn
                outlined
                small 
                height="32px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="clearFilters()"
                >Limpar Filtro</v-btn>
          </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex'
export default {
    data() {
        return {
          dateIFormatted: null,
          dateFFormatted: null,
          dateI: null,
          dateF: null,
          formData: {
            dt_inicio: null,
            dt_fim: null,
            grupo_economico: null,
            operadora_ans_id: [],
            prestador_id: [],
            status: null,
            user_id_upload: null,
          },
          operadorasFilter: [],
          prestadoresFilter: [],
          responsaveisFilter: [],
          statusFilter: [
            { id: null, descricao: 'Selecione',  color: null},
            // { id: 1, descricao: "Em validação", color: "#979797", icon: "fa-circle"},//
            { id: 2, descricao: "Em processamento", color: "#FC9D0A", icon: "fa-circle"},
            { id: 4, descricao: "Erro no arquivo", color: "#D0021B", icon: "fa-circle" },
            { id: 3, descricao: "Upload processado", color: "#32B88B", icon: "fa-circle"}
          ],
          searchInput: null
      }
    },
    computed: {
      ...mapState({
        formRules: state => state.formRules
      }),
    }, 
    watch: {
        prestadores:{
            deep: true,
            handler(val) {
                this.prestadoresFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.prestador_id = [val[0].id]
                }
            }
        },
        operadoras:{
            deep: true,
            handler(val){
                this.operadorasFilter = Array.from(val)
                if (val && val.length==1) {
                    this.formData.operadora_ans_id = [val[0].id]
                }
            }
        },
        responsaveis:{
            deep: true,
            handler(val){
                this.responsaveisFilter = Array.from(val)
                this.responsaveisFilter.unshift({Id: null, UserName: "Selecione"})
                if (val && val.length==1) {
                    this.formData.user_id_upload = [val[0].id]                   
                }
            }
        },
        dataReferencia:{
          deep: true,
          handler(val) {
            if (val) {
              this.dateFFormatted = this.formatDate(val.dt_fim)
              this.dateIFormatted = this.formatDate(val.dt_inicio)
            }
          }
        },
        dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.dt_fim = this.parseDate(val)
        },
        dateI(val){
          if (!val) {
            this.dateIFormatted = null
          } else {
            if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateF = val
            }
            this.dateIFormatted = this.formatDate(val)
          }
        },
        dateIFormatted(val){
          this.formData.dt_inicio = this.parseDate(val)
        },
    },
    mounted() {
      this.formData.grupo_economico = this.$store.state.permissions.grupoEconomico
      let opts = {
        grupoEconomico: this.formData.grupo_economico,
        modulo_operadora: "recebiveis",
        prestador_ids: []

      }
      this.getOperadoras(opts)
      this.getResponsaveis(opts)
      this.filterList(this.formData)
    },
    methods: {
        ...mapActions({
          getResponsaveis: "faturamento/getResponsaveis",
          getOperadoras: "permissions/getOperadoras",
          formatDate: "common/formatDate",
      }),
        changePrestador() {
          let opts = {
            grupoEconomico: this.formData.grupo_economico,
            modulo_operadora: "recebiveis",
            prestador_ids: this.formData.prestador_id
          }
          this.getOperadoras(opts)
          this.getResponsaveis(opts)
          this.formData.user_id_upload = null
          this.formData.operadora_ans_id = []
        },
        changeCarteira() {
          this.formData.operadora_ans_id = this.operadorasFilter.length==1? [this.operadorasFilter[0].id] : []
          this.formData.prestador_id = this.prestadoresFilter.length==1? [this.prestadoresFilter[0].id] : []
          this.formData.user_id_upload = this.responsaveisFilter.length==1? [this.responsaveisFilter[0].id] : []
        },
        clearFilters() {
          // this.$refs.filterUploadsMonitor.reset();
          this.dateIFormatted = null
          this.dateFFormatted = null
          this.dateI = null
          this.dateF = null
          this.formData.dt_inicio = null
          this.formData.dt_fim = null
          this.formData.status = null
          this.formData.user_id_upload = null;
          if (this.prestadoresFilter.length!=1) {
            this.formData.prestador_id = []
          }
          this.formData.operadora_ans_id = []
          this.filterList(this.formData)
        },
        formatDate(date) {
          if (!date) return null;
          date = date.substr(0, 10)
          const [year, month, day] = date.split("-");
          return `${day}/${month}/${year}`;
        },
        parseDate(date) {
          if (!date) return null;
          date = date.substr(0, 10)
          const [day, month, year] = date.split("/");
          return `${year}-${month}-${day}`;
        },
        sendFilter(){
          if(this.$refs.filterUploadsMonitor.validate()){
            if(!this.formData.data_ate && this.formData.data_entre) {
                this.dateF = this.formData.data_entre
                this.formData.data_ate = this.formData.data_entre
            }
            this.$nextTick(()=>this.filterList(this.formData))
          }
        },
        toggleAutocomplete(item, campo) {
          this.searchInput=null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
            this.formData[campo].push(item.id)
          }
            this.$nextTick(()=> {if(campo=='prestador_id') this.changePrestador()})
            return
        },
    },
    props: {
        dataReferencia: Object,
        prestadores: Array,
        operadoras: Array,
        responsaveis: Array,
        filterList: Function
    }
}
</script>

<style>

</style>